export const getToken = () => {
    return localStorage.getItem('userToken')
}

export const getWorkspaceID = () => {
    return localStorage.getItem('workspaceID')
}

export const getUserID = () => {
    return localStorage.getItem('userID')
}

export const setWorkspaceID = (workspaceID) => {
    localStorage.setItem('workspaceID', workspaceID)
}

export const getLastUsedWorkspaces = () => {
    const savedUsedWorkspaces = localStorage.getItem('lastUsedWorkspaces')
    let lastUsedWorkspaces = new Map()
    if (savedUsedWorkspaces) {
        lastUsedWorkspaces = JSON.parse(savedUsedWorkspaces, (key, value) => {
            if (typeof value === 'object' && value !== null)
                if (value.dataType === 'Map') return new Map(value.value)
            return value
        })
        return lastUsedWorkspaces
    }
    return new Map()
}

export const setLastUsedWorkspaces = (userID, workspaceID, workspaceName) => {
    const lastUsedWorkspaces = getLastUsedWorkspaces()
    lastUsedWorkspaces.set(userID, [workspaceID, workspaceName])
    localStorage.setItem(
        'lastUsedWorkspaces',
        JSON.stringify(lastUsedWorkspaces, (key, value) => {
            if (value instanceof Map) return { dataType: 'Map', value: Array.from(value.entries()) }
            else return value
        })
    )
}

export const parseBoolean = (str) => {
    if (str === 'true') return true
    else if (str === 'false') return false
    return undefined
}

export const safeEncodeForUrl = (jsonString) => {
    return btoa(jsonString).replace(/\+/g, '-').replace(/\//g, '_')
}

export const safeDecodeFromUrl = (encoded) => {
    return atob(encoded.replace(/-/g, '+').replace(/_/g, '/'))
}

export const encodeChatObject = (str, type) => {
    switch (type) {
        case 'tree':
            const treeObject = JSON.parse(str).graph
            treeObject.children.forEach((firstChild) => {
                delete firstChild.children
            })
            const stringTreeObject = JSON.stringify(treeObject)
            return safeEncodeForUrl(stringTreeObject)
        case 'chart':
            const chartObject = JSON.parse(str)
            console.log(chartObject)
            delete chartObject.description
            delete chartObject.aiDescription
            delete chartObject.aiSummary
            const stringChartObject = JSON.stringify(chartObject)
            return safeEncodeForUrl(stringChartObject)
        case 'cluster':
            const clusterObject = JSON.parse(str).clusters
            if (clusterObject.length) {
                clusterObject.forEach((cluster) => {
                    delete cluster.clusterDescription
                    delete cluster.queryFilter
                    delete cluster.attributes
                })
            }
            const stringClusterObject = JSON.stringify(clusterObject)
            return safeEncodeForUrl(stringClusterObject)
    }
}
